var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 121,
    height: 120,
    viewBox: "0 0 121 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M86.1302 47.2002C83.1102 47.2002 80.4102 48.5702 78.5502 50.7402V48.4602H70.9702V85.5002H79.3902V72.5302C81.2302 74.0602 83.5702 74.9802 86.1202 74.9802C93.5602 74.9802 99.5902 68.7602 99.5902 61.0902C99.5902 53.4202 93.5602 47.2002 86.1202 47.2002H86.1302ZM99.5902 61.0902C99.5902 53.4202 93.5602 47.2002 86.1202 47.2002L99.5902 61.0902ZM85.2802 67.2302C82.0302 67.2302 79.3902 64.4802 79.3902 61.0902C79.3902 57.7002 82.0302 54.9502 85.2802 54.9502C88.5302 54.9502 91.1702 57.7002 91.1702 61.0902C91.1702 64.4802 88.5302 67.2302 85.2802 67.2302Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M113.48 69.9299C113.48 72.7199 111.22 74.9799 108.43 74.9799C105.64 74.9799 103.38 72.7199 103.38 69.9299C103.38 67.1399 105.64 64.8799 108.43 64.8799C111.22 64.8799 113.48 67.1399 113.48 69.9299Z",
    fill: "#FFB400"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M60.8702 44.92C63.4714 44.92 65.5802 42.8113 65.5802 40.21C65.5802 37.6087 63.4714 35.5 60.8702 35.5C58.2689 35.5 56.1602 37.6087 56.1602 40.21C56.1602 42.8113 58.2689 44.92 60.8702 44.92Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M65.0802 48.46H56.6602V73.71H65.0802V48.46Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 36.6797V43.7497H17.94V73.7197H26.36V43.7497H37.3V36.6797H7Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M50.7699 48.3303C47.5899 48.3303 44.7999 49.9803 43.1899 52.4603V48.4603H35.6099V73.7103H44.0599V63.1103C44.0599 58.7603 47.2299 56.0403 51.1299 56.0403C51.5799 56.0403 52.0199 56.1003 52.4499 56.1803V48.4503C51.8999 48.3703 51.3399 48.3203 50.7699 48.3203V48.3303Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrip);
export default __webpack_public_path__ + "static/media/trip.321659778c52acb59b29106107b943a4.svg";
export { ForwardRef as ReactComponent };